var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  SearchPostalCode = require('_js/search-postal-code');

function RegistrationAgency(params) {
  var self = this;

  if (params.step === undefined) {
    throw 'No steps parameter passed to this component!';
  }

  self.parent = params.parent;
  self.API = params.api;

  self.componentActive = false;
  self.step = params.step;
  self.currentStep = ko.observable(self.parent.currentStep());

  // These input fields will be defined when searchOrganization is executed.
  self.inputFields = null;
  self.inputFieldsVisit = null;
  self.inputFieldsInvoice = null;
  self.currentInputField = 0;

  self.parent.currentStep.subscribe(function(val) {
    if (val === self.step()) {
      self.activateComponent();
    } else {
      self.deactivateComponent();
    }
  });

  self.isSearching = ko.observable(false);
  self.results = ko.observableArray([]);
  self.hasSearched = ko.observable(false);
  self.showWarningNextWithoutData = ko.observable(false);
  self.hasGottenResults = ko.observable(false);

  self.agency = ko.observable();

  self.showContactInformation = ko.observable(false);
  self.showInvoiceAccordion = ko.observable(false);
  self.showAddressAccordion = ko.observable(false);

  self.marketingName = ko.observable();
  self.headCount = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      },
      {
        type: 'isDecimalNumber',
        message: self.parent.errorMessages.invalidDecimalNumber
      }
    ]
  });
  self.registeredAuditor = ko.observable();
  self.co = ko.observable();
  self.postalAddress = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });
  self.postalCode = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: self.parent.errorMessages.notANumber
      },
      {
        type: 'isLength',
        message: self.parent.errorMessages.wrongNumberOfDigitsPostalCode,
        length: 4
      }
    ]
  });
  self.postalPlace = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });

  self.invoiceEmail = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      },
      { type: 'isEmail', message: self.parent.errorMessages.invalidEmail }
    ]
  });

  //Observables retalted to radio buttons
  self.resultOption = ko.observable(0);
  self.resultOption.subscribe(function(num) {
    self.populateInputFromApi(self.results()[num]);
    self.agency(self.results()[num]);
    self.isMember(self.results()[num].IsMember);
  });

  // Observables related to updating information from brreg.
  self.name = ko.observable();
  self.email = ko.observable();
  self.phone = ko.observable();
  self.website = ko.observable();

  self.isMember = ko.observable();

  // Observables related to showAddressAccordion :
  self.visitCo = ko.observable();
  self.postalAddress = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });
  self.visitAddress = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });
  self.visitPostalCode = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: self.parent.errorMessages.notANumber
      },
      {
        type: 'isLength',
        message: self.parent.errorMessages.wrongNumberOfDigitsPostalCode,
        length: 4
      }
    ]
  });
  self.visitPostalPlace = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });

  // Observables related to showInvoiceAccordion :
  self.invoiceCo = ko.observable();
  self.invoiceAddress = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });
  self.invoicePostalCode = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: self.parent.errorMessages.notANumber
      },
      {
        type: 'isLength',
        message: self.parent.errorMessages.wrongNumberOfDigitsPostalCode,
        length: 4
      }
    ]
  });
  self.invoicePostalPlace = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });

  self.searchOrganization = function() {
    if (self.searchQuery() === undefined) {
      return;
    }
    if (self.searchQuery.hasError()) {
      return;
    }
    self.isSearching(true);
    var url =
      self.API.getAgencies +
      '?orgnr=' +
      encodeURIComponent(self.searchQuery().trim());
    APIHelper.get(
      url,
      function(data) {
        self.hasSearched(true);
        self.resultOption(0);
        self.showContactInformation(false);
        self.results(data);
        self.agency(data[0]);
        self.populateInputFromApi(data[0]);
        self.inputFields = $('.form-info-agency').find(':input');
        self.inputFieldsVisit = $('.form-info-agency-visit').find(':input');
        self.inputFieldsInvoice = $('.form-info-agency-invoice').find(':input');
        self.parent.addInputControlForPage(self.inputFields);
        self.parent.addInputControlForPage(self.inputFieldsVisit);
        self.parent.addInputControlForPage(self.inputFieldsInvoice);
        self.isSearching(false);
        if (data.length < 1) {
          self.showWarningNextWithoutData(true);
          self.hasGottenResults(false);
        } else {
          self.showWarningNextWithoutData(false);
          self.hasGottenResults(true);
        }
      },
      function(response) {
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: registration-agency.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  };
  self.searchQuery = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: self.parent.errorMessages.notANumber
      },
      {
        type: 'isLength',
        message:
          self.parent.errorMessages.wrongNumberOfDigitsOrganizationNumber,
        length: 9
      }
    ]
  });

  self.recruiter = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: self.parent.errorMessages.notANumber
      },
      {
        type: 'isLength',
        message: self.parent.errorMessages.wrongNumberOfDigitsMembershipNumber,
        length: 8
      },
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });

  self.requiredFields = [
    self.invoiceEmail,
    self.searchQuery,
    self.headCount,
    self.postalAddress,
    self.postalCode
  ];

  var regData = sessionStorage.getItem('rn-registration');
  if (regData !== undefined && regData !== null) {
    var parsedRegData = JSON.parse(regData);
    if (parsedRegData.infoAgency !== undefined) {
      this.populateInputFromStore(parsedRegData.infoAgency);
    }
  }
}

RegistrationAgency.prototype.init = function(element) {
  this.$element = $(element);
  var self = this;

  self.searchPostalPlaceEl = this.$element.find("[data-postal-place='1']");
  self.visitPostalPlaceEl = this.$element.find("[data-postal-place='2']");
  self.invoicePostalPlaceEl = this.$element.find("[data-postal-place='3']");

  var searchPostalCode = new SearchPostalCode(null, self.postalPlace);

  self.postalCode.subscribe(function(val) {
    searchPostalCode.searchForCity(val);
  });

  var addressPostalCode = new SearchPostalCode(null, self.visitPostalPlace);

  self.visitPostalCode.subscribe(function(val) {
    addressPostalCode.searchForCity(val);
  });

  var invoicePostalCode = new SearchPostalCode(null, self.invoicePostalPlace);

  self.invoicePostalCode.subscribe(function(val) {
    invoicePostalCode.searchForCity(val);
  });

  self.showAddressAccordion.subscribe(function(val) {
    var $visitAddress = $(self.$element.find("[data-visit-address='true']"));
    if (val === true) {
      $visitAddress.slideDown(250, 'easeOutQuad');
    } else {
      $visitAddress.slideUp(250, 'easeOutQuad');
    }
  });

  self.showInvoiceAccordion.subscribe(function(val) {
    var $invoiceAddress = $(
      self.$element.find("[data-invoice-address='true']")
    );
    if (val === true) {
      $invoiceAddress.slideDown(250, 'easeOutQuad');
    } else {
      $invoiceAddress.slideUp(250, 'easeOutQuad');
    }
  });

  // self.parent.addInputControlForPage(self.inputFields);
};

RegistrationAgency.prototype.activateComponent = function() {
  var self = this;
  // Since this is called in the constructor we need to do verify that we are at the correct step.
  if (self.step() === self.parent.currentStep()) {
    self.componentActive = true;
    // self.parent.addInputControlForPage(self.inputFields);
  }
};

RegistrationAgency.prototype.deactivateComponent = function() {
  var self = this;
  // If the component is already deactivated we can just exit the function.
  if (!self.componentActive) {
    return;
  }
  // Only deactivate the component if the current step is not this step.
  if (self.step() !== self.parent.currentStep()) {
    self.componentActive = false;
    self.parent.removeInputControlForPage(self.inputFields);
    self.parent.removeInputControlForPage(self.inputFieldsVisit);
    self.parent.removeInputControlForPage(self.inputFieldsInvoice);
  }
};

// This function originally only did a console.log. I removed the console log but I'm afraid to delete this method.
RegistrationAgency.prototype.submitForm = function() {};

RegistrationAgency.prototype.populateInputFromApi = function(data) {
  this.name(data.Name);
  this.email(data.Email);
  this.phone(data.OfficePhone);
  this.website(data.Website);

  this.marketingName(data.MarketName);

  this.co(data.PostalCareOf);
  this.postalAddress(data.PostalAddress);
  this.postalCode(data.PostalPostCode);
  this.postalPlace(data.PostalCity);

  this.visitCo(data.StreetCareOf);
  this.visitAddress(data.StreetAddress);
  this.visitPostalCode(data.StreetPostCode);
  this.visitPostalPlace(data.StreetCity);

  this.invoiceCo(data.BillingCareOf);
  this.invoiceAddress(data.BillingAddress);
  this.invoicePostalCode(data.BillingPostCode);
  this.invoicePostalPlace(data.BillingCity);

  this.isMember(data.IsMember);
};

RegistrationAgency.prototype.populateInputFromStore = function(store) {
  this.agency(store.agency);
  this.marketingName(store.agency.MarketName);
  this.headCount(store.agency.Employees);
  this.co(store.agency.PostalCareOf);
  this.postalAddress(store.agency.PostalAddress);
  this.postalCode(store.agency.PostalPostCode);
  this.postalPlace(store.agency.PostalCity);
  this.invoiceEmail(store.agency.InvoiceEmail);

  this.visitCo(store.agency.StreetCareOf);
  this.visitAddress(store.agency.StreetAddress);
  this.visitPostalCode(store.agency.StreetPostCode);
  this.visitPostalPlace(store.agency.StreetCity);

  this.invoiceCo(store.agency.BillingCareOf);
  this.invoiceAddress(store.agency.BillingAddress);
  this.invoicePostalCode(store.agency.BillingPostCode);
  this.invoicePostalPlace(store.agency.BillingCity);
};

RegistrationAgency.prototype.createStoreObject = function() {
  var tmpAgency = this.agency();
  tmpAgency.Email = this.email();
  tmpAgency.OfficePhone = this.phone();
  tmpAgency.Website = this.website();

  tmpAgency.ApprovedAuditor = this.registeredAuditor();
  tmpAgency.InvoiceEmail = this.invoiceEmail();
  tmpAgency.MarketName = this.marketingName();
  tmpAgency.Employees = parseFloat(this.headCount().replace(',', '.'), 10);
  tmpAgency.PostalCareOf = this.co();
  tmpAgency.PostalAddress = this.postalAddress();
  tmpAgency.PostalPostCode = this.postalCode();
  tmpAgency.PostalCity = this.postalPlace();

  tmpAgency.StreetCareOf = this.visitCo();
  tmpAgency.StreetAddress = this.visitAddress();
  tmpAgency.StreetPostCode = this.visitPostalCode();
  tmpAgency.StreetCity = this.visitPostalPlace();

  tmpAgency.BillingCareOf = this.invoiceCo();
  tmpAgency.BillingAddress = this.invoiceAddress();
  tmpAgency.BillingPostCode = this.invoicePostalCode();
  tmpAgency.BillingCity = this.invoicePostalPlace();

  // Store all the observable values into an object.
  return {
    agency: tmpAgency
  };
};

RegistrationAgency.prototype.storeValues = function() {
  this.parent.storeValuesForStep('infoAgency', this.createStoreObject());
};

RegistrationAgency.prototype.validateInputOnStep = function() {
  if (!this.hasGottenResults() && this.searchQuery.hasError() === false) {
    this.showWarningNextWithoutData(true);
    return false;
  } else {
    return this.parent.validateFields(this.requiredFields);
  }
};

RegistrationAgency.prototype.toggleAddressAccordion = function() {
  this.showAddressAccordion(!this.showAddressAccordion());
};

RegistrationAgency.prototype.toggleInvoiceAccordion = function() {
  this.showInvoiceAccordion(!this.showInvoiceAccordion());
};

RegistrationAgency.prototype.updateContactInformation = function() {
  this.showContactInformation(!this.showContactInformation());
};

RegistrationAgency.prototype.previousStep = function() {
  this.parent.previousStep();
};

RegistrationAgency.prototype.nextStep = function() {
  // 1: Validate step. If successful, goto next step.
  if (!this.validateInputOnStep()) {
    var location = window.location.href || document.URL;
    APIHelper.post('/api/log/error', {
      message: 'NOT-VALIDATED: registration-agency.js',
      context: location,
      parameters: [
        'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
        'platform: ' + navigator.platform
      ]
    });
    return;
  }

  // 2: Store values inputted by the user into Storage.
  this.storeValues();

  // 3: Allow to continue execution.
  this.parent.nextStep();
};

// Just used for testing.
RegistrationAgency.prototype.nextStepSkip = function() {};

module.exports = RegistrationAgency;
